const url = "/orgaos";
const id = "id"

export function buscarPeloCodigo(codigo) {
    return new Promise((resolve, reject) => {
        window.$http.get(`${url}/${codigo}`).then((res) => {
            resolve(res.data);
        })
    })
}

export function pesquisarAll() {
    return new Promise((resolve, reject) => {
        window.$http.get(`${url}/naoextintos/semOrgaosVinculados`).then((res) => {
            resolve(res.data);
        })
    })
}

export function salvar(parm) {
    return new Promise(async (resolve, reject) => {
        if (parm[id] && parm[id] != 0) {
            await atualizar(parm).then((res) => {
                resolve({ ...res, type: "UPD" });
            });
        } else {
            await criar(parm).then((res) => {
                resolve({ ...res, type: "INS" });
            })
        }
    })
}

export function remover(data) {
    return new Promise((resolve, reject) => {
        window.$http.delete(`${url}/${data[id]}`).then((res) => {
            resolve();
        })
    })
}

export function atualizar(parm) {
    return new Promise((resolve, reject) => {
        window.$http.put(`${url}/${parm[id]}`, JSON.stringify(parm)).then((res) => {
            resolve(res.data);
        })
    })
}

export function criar(parm) {
    return new Promise((resolve, reject) => {
        window.$http.post(`${url}`, JSON.stringify(parm)).then((res) => {
            resolve(res.data);
        })
    })
}






